import { render } from "./BookRoom.vue?vue&type=template&id=1bb4bac7"
import script from "./BookRoom.vue?vue&type=script&lang=js"
export * from "./BookRoom.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__